import { logWrapper } from '../utils';

export default {
  featureModel: [
    'runtimeConstant',
    'EFeatures',
    'EAdminFeatures',
    function (runtimeConstant, EFeatures, EAdminFeatures) {
      function Feature(data, isAdminFeature) {
        this.id = data;
        this.name = isAdminFeature
          ? getAdminFeatureName(data)
          : getFeatureName(data);

        this.selected = false;
      }

      var getFeatureName = (value) => {
        switch (value) {
          case EFeatures.CHANGE_PROPERTIES:
            return 'Alterar Propriedades';
          case EFeatures.APPROVE_DOCUMENT_IN_FLOW:
            return 'Aprovar Documento em Fluxo';
          case EFeatures.CANCEL_CHECKOUT:
            return 'Cancelar Check-out do Documento';
          case EFeatures.CANCEL_FLOW:
            return 'Cancelar Fluxo de Documentos';
          case EFeatures.CHECKOUT_CHECKIN:
            return 'Check-out/Check-in';
          case EFeatures.SEND_DOCUMENT:
            return 'Cadastrar Documento';
          case EFeatures.SEND_BY_EMAIL:
            return 'Enviar por Email';
          case EFeatures.NOTIFY_USERS:
            return 'Notificar Usuários';
          case EFeatures.DOWNLOAD:
            return 'Download';
          case EFeatures.DOWNLOAD_OLD_REVISIONS:
            return 'Download de Revisões Anteriores';
          case EFeatures.SHARE_DOCUMENT:
            return 'Compartilhar Documento';
          case EFeatures.DELETE_DOCUMENT:
            return 'Excluir Documento';
          case EFeatures.REVERT_REVISION:
            return 'Reverter Revisão';
          case EFeatures.REVIEW_DOCUMENT_IN_FLOW:
            return 'Revisar Documento em Fluxo';
          case EFeatures.REPLACE_FILE:
            return 'Substituir Arquivo';
          case EFeatures.VIEW_DOCUMENT:
            return 'Visualizar Revisão';
          case EFeatures.VIEW_OLD_REVISIONS:
            return 'Visualizar Revisões Anteriores';
          case EFeatures.PRINT:
            return 'Imprimir';
          case EFeatures.DIGITAL_SINATURE:
            return 'Assinar Digitalmente';
          case EFeatures.LINK_FILE:
            return 'Vincular Documentos';
          case EFeatures.BECOME_OBSOLETE:
            return 'Tornar Documento Obsoleto';
          case EFeatures.SIGNATURE_D4SIGN:
            return 'Assinar com D4Sign';
          case EFeatures.SIGNATURE_CERTIFICATA:
            return 'Assinar com Certificata';
          case EFeatures.DOCUMENT_AUDIT:
            return 'Auditoria do Documento';
          case EFeatures.CONVERT_PDF:
            return 'Coverter para PDF';
          default:
            return `Ooops Ocorreu Um Erro !! (${value})`;
        }
      };

      var getAdminFeatureName = (value) => {
        switch (value) {
          case EAdminFeatures.ConfigureDigitalization:
            return 'Configurar Digitalização';
          case EAdminFeatures.ConfigureSystemOptions:
            return 'Configurar Opções do Sistema';
          case EAdminFeatures.ManageExtensions:
            return 'Gerenciar Extensões dos Arquivos';
          case EAdminFeatures.ManageGroups:
            return 'Gerenciar Grupos';
          case EAdminFeatures.ManageUsers:
            return 'Gerenciar Usuários';
          case EAdminFeatures.ManageRoles:
            return 'Gerenciar Papéis';
          case EAdminFeatures.ManagePhysicalLocalizations:
            return 'Gerenciar Localizações Físicas';
          case EAdminFeatures.ManageRepositories:
            return 'Gerenciar Repositórios';
          case EAdminFeatures.ManageMediaTypes:
            return 'Gerenciar Tipos de Mídia';
          case EAdminFeatures.ManageDocumentTypes:
            return 'Gerenciar Tipos de Documento';
          case EAdminFeatures.ManageWorkflows:
            return 'Gerenciar Workflows';
          case EAdminFeatures.ManageDataLists:
            return 'Gerenciar Listas';
          case EAdminFeatures.ManageAdditionalFields:
            return 'Gerenciar Campos Adicionais';
          case EAdminFeatures.ViewReports:
            return 'Gerar Relatórios (Dashboard)';
          case EAdminFeatures.RegisterSystem:
            return 'Registrar o Sistema';
          case EAdminFeatures.ManageTrashCan:
            return 'Gerenciar Lixeira';
          case EAdminFeatures.ManageFolders:
            return 'Gerenciar Pastas';
          case EAdminFeatures.ExportMedia:
            return 'Gerar Mídia';
          case EAdminFeatures.ManageNFes:
            return 'Gerenciar Notas Fiscais';
          case EAdminFeatures.AutoComplete:
            return 'Gerenciar Título Automático';
          case EAdminFeatures.CanD4SignIntegrate:
            return 'Assinar com a D4Sign';
          case EAdminFeatures.CanCertificataIntegrate:
            return 'Assinar com Certificata';
          case EAdminFeatures.ManageExpire:
            return 'Gerenciar Data de Validade';
          case EAdminFeatures.SharedFolder:
            return 'Compartilhar pasta';
          case EAdminFeatures.OnlyCreateFolder:
            return 'Somente criar pastas';
          default:
            return `Ooops Ocorreu Um Erro !! (${value})`;
        }
      };

      function title() {
        return this.name;
      }

      function details() {
        return '';
      }

      function tags() {
        return '';
      }

      function run() {
        try {
          Feature.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
          };

          return Feature;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
